import { faTag } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { ProjectGq } from '../../../../../graphql/projects/models/ProjectGq';
import DataTableToolbarButton from '../../../../voxel/DataTableToolbar/DataTableToolbarButton';
import { KeywordTableState } from '../logic/useKeywordTableState';

export interface TagsButtonProps {
  tableState: KeywordTableState;
  project: ProjectGq;
  selectionActive?: boolean;
}

export const TagsButton: React.FC<TagsButtonProps> = ({ tableState, selectionActive }) => {
  const handleToggleTags = () => {
    tableState.setTableUIState((prev) => ({
      ...prev,
      showDomainsPanel: false,
      showTagPanel: !prev.showTagPanel,
    }));
  };

  return (
    <DataTableToolbarButton
      tooltip={selectionActive ? "Tag or untag selected keywords" : "Toggle tag panel"}
      label="Tag"
      iconProp={faTag}
      onClick={handleToggleTags}
      toggle={tableState.tableUIState.showTagPanel}
      effect={selectionActive ? 'primary' : undefined}
      effectAnimate={false}
    />
  );
};

export default TagsButton;
